module.exports = {
  "assetPreviewInteraction": {
    "name": "Asset preview interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "open preview",
        "click asset image preview",
        "click view performance",
        "open tab assets",
        "open tab details",
        "open tab performance",
        "open tab activity",
        "collapse association group",
        "expand association group",
        "inline edit success",
        "inline edit failure",
        "click view utm details",
        "delete utm success",
        "utm data loaded"
      ],
      "applicationId": {
        "type": "string"
      },
      "objectType": {
        "type": "string"
      },
      "originObjectType": {
        "type": "string",
        "isOptional": true
      },
      "previewType": {
        "type": [
          "popover",
          "sidebar",
          "sidepanel",
          "card"
        ]
      },
      "numberOfProperties": {
        "type": "number",
        "isOptional": true
      },
      "isUTMUpdated": {
        "isOptional": true,
        "type": "boolean"
      },
      "maxCount": {
        "isOptional": true,
        "type": "number"
      },
      "editedProperties": {
        "isOptional": true,
        "type": "array"
      }
    },
    "namespace": "framework-asset-preview-lib",
    "version": "1"
  }
};